import React from "react";
import "./Responsible-Gaming.css";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { PageVisit } from "../../../Utility/API";

const Responsiblegaming = () => {

  const state = useSelector((state) => state);

  useEffect(()=>{
     PageVisit(state?.auth?.user?.idUser || "","responsible-gaming");
   },[]);

  return (
    <div>

       <Helmet>
       <title>Responsible Gaming | BettDraft Fantasy Sports </title>

        <meta
          name="description"
          content="BettDraft encourages responsible gaming. If it stops being fun, learn more about the available resources."
        />

        <link
          rel="canonical"
          href="https://dfs.bettdraft.com/responsible-gaming"
        />
        </Helmet>


      <div className="container bg-color-rg space-bottom">
        <div className="inner-smallspace-rg">
          <div className="row">

            <div className="col-md-12">
              <div className="content-page-design">
                <h2>RESPONSIBLE GAMING</h2>
                {/* <h4>RESPONSIBLE GAMING</h4> */}
                <p>BettDraft offers real-money contest entries on its site and application. We advise you to please engage in responsible gaming and only submit contest entries at a value or total amount that is within your means. If you or someone you know has a gambling problem, assistance is available. Call (<a href="tel:1-800-522-4700">1-800-522-4700</a>). For additional help and support regarding gambling addiction, please reach out to:</p>
      
                <p>
                  <li> The National Council on Problem Gambling at <a href="tel:1-800-522-4700">1-800-522-4700</a> or visit <a href="https://www.ncpgambling.org" target="_blank">www.ncpgambling.org.</a></li>
                  <br></br>
                  <li> National Suicide Prevention at 1-800-273-8255 or visit <a href="https://www.suicidepreventionlifeline.org" target="_blank">www.suicidepreventionlifeline.org</a>.</li><br></br>
                  <li> Gamblers Anonymous <a href="https://www.gamblersanonymous.org/ga" target="_blank">www.gamblersanonymous.org/ga</a></li><br/>
                  <li>GAM-ANON - <a href="https://www.gam-anon.org" target="_blank">www.gam-anon.org</a></li>
                </p>

                <p>BettDraft offer all of our customers access to tools that allow you to manage and control your spend and time on site. If you have any questions on how to manage and set self-imposed limits, please contact customer support</p>
                <p>
                You can choose to set and control the total value of contest entries you can submit per day, week or month. This gives you full control to set your limits and you will not be able to increase these until the period has completed.
                </p>
                <p>If you feel like you need a break, you can impose a Cool-Off period, where you will be locked out of your account for a period of your choosing up to a maximum of 30 days. During this time, you will not be able to login to your account. Any entries that were open at the time of cool off will remain active and any winnings will be waiting for you once your cool off period is over.</p>
                
                <p>
                We understand that some individuals may require assistance in managing their gambling activities responsibly. Therefore, you can reach out to our customer support team at <a href="mailto:support@bettdraft.com">support@bettdraft.com</a> and an agent will be happy to set your limits for you or apply a full self-exclusion from our site and applications. When you self-exclude, any open contest entries will be voided and refunded. Your account access will be completely removed, and all account funds will be returned to your Skrill wallet. You may then process your withdrawal to your bank account
                </p>



              </div>

            </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default Responsiblegaming;
